<template>
  <div class="do-mgt">
    <div class="do-mgt__version">
      <span> Environment: </span>

      <el-select
        class="do-mgt__service-options"
        v-model="selectedCanary"
        placeholder="Select environment"
        :disabled="
          loading.repoBranches || loading.deploy || loading.canaryActivities
        "
      >
        <el-option
          v-for="(canary, index) in canaryNames"
          :key="index"
          :label="canary.name"
          :value="canary.value"
        />
      </el-select>
    </div>

    <div shadow="hover" class="do-mgt__content">
      <div class="do-mgt__services" v-loading="loading.repoBranches">
        <div v-for="(service, index) in serviceOptions" :key="index">
          <div class="do-mgt__services--branches">
            <span> {{ service.name }}: </span>

            <el-select
              class="do-mgt__service-options"
              v-model="selectedBranches[index].value"
              filterable
              placeholder="Select branch"
              :disabled="loading.deploy"
              :loading="loading.repoBranches || loading.deploy"
              loading-text="Loading..."
            >
              <el-option
                v-for="(branch, index) in branches(service.name)"
                :key="index"
                :label="branch"
                :value="branch"
              />
            </el-select>
          </div>

          <div class="do-mgt__services--links">
            <a
              :href="`https://${selectedCanary}-${service.host}/gitver`"
              target="_blank"
            >
              Live commit</a
            >
            <a
              v-for="(item, index) in links(service.name)"
              :key="`${index}${item.name}`"
              :href="item.link"
              target="_blank"
            >
              {{ item.name }}
            </a>
          </div>
        </div>

        <div class="do-mgt__deploy-btn">
          <el-button type="primary" @click="deploy" v-loading="loading.deploy">
            Deploy
          </el-button>
        </div>
      </div>

      <div class="do-mgt__activities" v-loading="loading.canaryActivities">
        <div>
          <el-row style="">
            <el-col style="font-weight: bold"> </el-col>
          </el-row>
        </div>

        <el-row style="margin-top: 30px">
          <el-col :span="12" style="font-weight: bold; text-align: center">
            Start Time
          </el-col>
          <el-col :span="12" style="font-weight: bold; text-align: center">
            User
          </el-col>
          <el-col style="font-weight: bold; text-align: center">
            anima-api
          </el-col>
          <el-col style="font-weight: bold; text-align: center">
            anima-codegen
          </el-col>
          <el-col style="font-weight: bold; text-align: center">
            anima-web
          </el-col>
        </el-row>

        <el-row v-for="activity in canaryActivities" :key="activity.id">
          <el-col :span="12" style="text-align: center">
            {{ activity.date }}
          </el-col>
          <el-col :span="12" style="text-align: center">
            {{ activity.user.name }}
          </el-col>
          <el-col style="text-align: center">
            {{ activity.context["branches"]?.["anima-api"] }}:{{
              activity?.context["commit_shas"]?.["anima-api"].slice(-7)
            }}
            <span style="color: red">{{
              activity.context["deployments_status"]?.["anima-api"]
            }}({{
                formatDuration(activity.context["durations"]?.["anima-api"])
              }})</span>
          </el-col>
          <el-col style="text-align: center">
            {{ activity.context["branches"]?.["anima-codegen"] }}:{{
              activity?.context["commit_shas"]?.["anima-codegen"].slice(-7)
            }}
            <span style="color: red">{{
              activity.context["deployments_status"]?.["anima-codegen"]
            }}({{
                formatDuration(activity.context["durations"]?.["anima-codegen"])
              }})</span>
          </el-col>
          <el-col style="text-align: center">
            {{ activity.context["branches"]?.["anima-web"] }}:{{
              activity?.context["commit_shas"]?.["anima-web"].slice(-7)
            }}
            <span style="color: red"
              >{{ activity.context["deployments_status"]?.["anima-web"] }}
              ({{
                formatDuration(activity.context["durations"]?.["anima-web"])
              }})</span
            >
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { canaryNames, serviceOptions } from "./constants";

export default {
  name: "Devops",

  data() {
    return {
      canaryNames,
      serviceOptions,
      selectedCanary: this.$route.query.env || canaryNames[0].value,
      selectedBranches: [
        { name: "anima_api", value: "master" },
        { name: "anima_codegen", value: "master" },
        { name: "anima_web", value: "master" },
      ],
      deploymentStatus: {
        "anima-api": "",
        "anima-codegen": "",
        "anima-web": "",
      },
      liveCommitSha: {
        "anima-api": "",
        "anima-codegen": "",
        "anima-web": "",
      },
      pollingTimers: {
        "anima-api": "",
        "anima-codegen": "",
        "anima-web": "",
      },
    };
  },

  filters: {
    truncateHash(hash) {
      return hash.substring(0, 10);
    },

    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },

  computed: {
    ...mapGetters([
      "loading",
      "repoBranches",
      "repoLinks",
      "canaryActivities",
      "deployRequest",
      "deployRequestStatus",
    ]),

    allBranchesSelected() {
      return this.selectedBranches.every((branch) => branch.value.length);
    },
  },

  methods: {
    ...mapActions(["getRepoBranches", "getCanaryActivities", "deployBranch"]),

    formatDuration(seconds) {
      if (!seconds) {
        return '';
      }
      return new Date(seconds * 1000).toLocaleTimeString("en-GB", {
        timeZone: "Etc/UTC",
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },

    branches(repoName) {
      const { api, web, codegen } = this.repoBranches;

      if (repoName === "anima-api") return api;
      if (repoName === "anima-web") return web;
      return codegen;
    },

    links(repoName) {
      const { api, web, codegen } = this.repoLinks;

      if (repoName === "anima-api") return api;
      if (repoName === "anima-web") return web;
      return codegen;
    },

    getAllRepoBranches() {
      serviceOptions.forEach((service) => {
        this.getRepoBranches(service.name);
      });
    },

    async deploy() {
      if (!this.allBranchesSelected) return;

      await this.deployBranch({
        source_branches: {
          "anima-api": this.selectedBranches[0].value,
          "anima-codegen": this.selectedBranches[1].value,
          "anima-web": this.selectedBranches[2].value,
        },
        target_branch: this.selectedCanary,
      });

      if (this.deployRequest.code == 200) {
        this.$message.success("Deploy initiated successfully");
        this.resetSelectedBranches();
        this.getCanaryActivities(this.selectedCanary);
      } else {
        this.$notify.error({
          title: "Error",
          message: "Failed to deploy",
        });
      }
    },

    resetSelectedBranches() {
      this.selectedBranches = [
        { name: "anima_api", value: "" },
        { name: "anima_codegen", value: "" },
        { name: "anima_web", value: "" },
      ];
    },
  },

  watch: {
    selectedCanary: {
      immediate: true,
      handler: function (selectedCanary) {
        this.getCanaryActivities(selectedCanary);

        const query = { ...this.$route.query, env: selectedCanary };
        this.$router.replace({ query });
      },
    },
  },

  mounted() {
    if (this.$route.query.env) {
      this.selectedCanary = this.$route.query.env;
    }

    this.getAllRepoBranches(this.selectedCanary);
  },
};
</script>

<style scoped>
.do-mgt {
  margin: 50px 15px;
}

.do-mgt__version {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
}

.do-mgt__services {
  padding: 40px;
  border-right: 1px solid black;
}

.do-mgt__services--branches {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.do-mgt__services--links {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 5px 0 30px;
}

.do-mgt__services--links > * {
  margin-left: 15px;
}

a {
  text-decoration: none;
  color: blue;
}

a:hover {
  text-decoration: underline;
}

.do-mgt__service-options {
  margin-left: 15px;
  width: fit-content;
}

.do-mgt__content {
  background: white;
  margin: 10px auto;
  padding: 50px 15px;
  min-height: 400px;
  display: flex;
}

.do-mgt__activities {
  flex: 1;
  padding-left: 20px;
  min-height: 80%;
}

.do-mgt__activities > div {
  font-size: 14px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.do-mgt__deploy-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

@media screen and (max-width: 600px) {
  .do-mgt__content {
    display: block;
  }

  .do-mgt__services {
    padding: 0 0 20px;
    margin-bottom: 20px;
    border-right: none;
    border-bottom: 0.5px solid black;
  }

  .do-mgt__content > * {
    width: 100%;
  }

  .do-mgt__activities,
  .do-mgt__deploy-btn,
  .do-mgt__services--branches,
  .do-mgt__services--links {
    margin-right: 20px;
  }
}
</style>
